import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { SavedViewLimitAlert } from './SavedViewLimitAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const VIEW_LIMIT_PERCENT_THRESHOLD = 75;
export const ViewLimitsSection = ({
  count,
  limit
}) => {
  const percentOfViewsUsed = count / limit * 100;
  const viewLimitAlert = /*#__PURE__*/_jsx(SavedViewLimitAlert, {
    viewCount: count,
    viewLimit: limit,
    percentOfViewsUsed: percentOfViewsUsed
  });
  const viewCountSection = /*#__PURE__*/_jsx(FormControl, {
    children: /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.cloneViewModal.viewLimits.notification",
        options: {
          count,
          limit
        }
      })
    })
  });
  return percentOfViewsUsed >= VIEW_LIMIT_PERCENT_THRESHOLD ? viewLimitAlert : viewCountSection;
};